module.exports = __webpack_public_path__ + "assets/15ad709c39ea23cfe368dfa4d7d28133.png";